import { Group } from 'three';
import { computeBoundingBox, disposeAllChildren, disposeAllChildrenThenRemoveFromParent } from '../utils';

class BaseModel2d {
  protected _modelGroup: Group = new Group();

  setDisplayOrder(order: number) {
    this._modelGroup.position.z = order;
  }

  setVisible(visible: boolean) {
    this._modelGroup.visible = visible;
  }

  getVisible() {
    return this._modelGroup.visible;
  }

  getBoundingBox() {
    return computeBoundingBox(this._modelGroup);
  }

  clear() {
    disposeAllChildren(this._modelGroup);
    this._modelGroup.scale.set(1, 1, 1);
  }

  dispose() {
    disposeAllChildrenThenRemoveFromParent(this._modelGroup);
  }
}

export default BaseModel2d;
